import { render } from "./RecipeCard.vue?vue&type=template&id=e5ccae34"
import script from "./RecipeCard.vue?vue&type=script&lang=js"
export * from "./RecipeCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__